export default "__VITE_ASSET__e4dfe140__"